import { underscore } from '@ember/string';

import RegisterPartnerJsSerializer from './-json-api';

export default class SdkKycTokenSerializer extends RegisterPartnerJsSerializer {
  payloadKeyFromModelName(modelName) {
    let payloadKey = super.payloadKeyFromModelName(modelName);

    return underscore(payloadKey);
  }
}
